export default __webpack_public_path__ + "8c37ee54cfd191cea6a2ce217c557b83.svg";